export enum ClientOccupationEnum {
    Entrepreneur = "Przedsiębiorca/Samozatrudnienie/Wolny zawód",
    PublicSectorEmployee = "Pracownik sfery budżetowej/Edukacja",
    FinanceProductEmployee = "Pracownik działu finansowego/produktowego",
    SalesMarketingEmployee = "Pracownik działu sprzedaży/marketingu/obsługi klienta",
    TechnicalWorker = "Pracownik techniczny",
    ITAdminEmployee = "Pracownik działu IT/administracji",
    MiddleTopManagement = "Kadra zarządzająca średniego i wyższego szczebla",
    ProfessionalDriver = "Kierowca zawodowy",
    SalesRepresentative = "Przedstawiciel handlowy",
    Lawyer = "Prawnik",
    UniformedServices = "Służby mundurowe",
    Athlete = "Sportowiec",
    Homemaker = "Gospodyni domowa",
    Farmer = "Rolnik",
    RetiredPensioner = "Emeryt/rencista",
    Student = "Student/uczeń",
    Unemployed = "Bezrobotny",
    ManualWorker = "Pracownik fizyczny",
    Other = "Inny",
    NotSpecified = "Nie podano",
    Neutral = "Neutralny",
}